/* eslint-disable max-len */
import EDC from '../../shared/globals';
import Answer from './answer';

/**
 *
 */
EDC.Games.CountingDots.AnswersBox = function (scene) {
  this.scene = scene;
  this.container = null;
  this.answers = [];
  this.answersData = [];
  this.correctValue = -1;
  this.stepX = 0;
  this.timer = null;
  this.disappearedCount = 0;
};
/**
 *
 */
EDC.Games.CountingDots.AnswersBox.prototype.create = function (y) {
  this.container = this.scene.add.container(0, y);
  this.scene.events.on(this.scene.signals.S_ANSWER_DISAPPEARED, this.onAnswerDisappeared, this);
  this.timer = this.scene.time.addEvent(
    {
      delay: 7000, callback: this.randomShake, callbackScope: this, loop: true,
    },
  );
  return this;
};
/**
 *
 */
EDC.Games.CountingDots.AnswersBox.prototype.onAnswerDisappeared = function () {
  this.disappearedCount += 1;
  if (this.disappearedCount >= this.answers.length) {
    this.scene.events.emit(this.scene.signals.S_ALL_ANSWERS_DISAPPEARED);
  }
};
/**
 *
 */
EDC.Games.CountingDots.AnswersBox.prototype.hideAnswers = function () {
  this.disappearedCount = 0;
  this.timer.paused = true;
  for (let i = 0; i < this.answers.length; i++) {
    this.answers[i].disappear();
  }
};
/**
 *
 */
EDC.Games.CountingDots.AnswersBox.prototype.randomShake = function () {
  const rndIndex = Math.floor(Math.random() * this.answers.length);
  this.answers[rndIndex].shake();
};
/**
 *
 */
EDC.Games.CountingDots.AnswersBox.prototype.updateData = function (answersData, correctValue) {
  this.answersData = answersData;
  this.correctValue = correctValue;
  for (let i = 0; i < this.answers.length; i++) {
    this.answers[i].destroy();
  }
  this.answers = [];
  this.createAnswers();
};
/**
 *
 */
EDC.Games.CountingDots.AnswersBox.prototype.createAnswers = function () {
  const totalCount = this.answersData.length;
  let totalWidth = 0;
  for (let i = 0; i < totalCount; i++) {
    const value = this.answersData[i];
    const isCorrect = value === this.correctValue;
    const answer = new Answer(this.scene, this.container, value, 500, i, isCorrect).create(totalWidth, 0);
    answer.appear();
    totalWidth += answer.getWidth() + this.stepX;
    this.answers.push(answer);
  }
  this.container.setPosition(this.scene.game.scale.width / 2 - totalWidth / 2, 760);
  this.timer.paused = false;
};
/**
 *
 */
EDC.Games.CountingDots.AnswersBox.prototype.deactivateAnswers = function () {
  this.answers.forEach((elem) => {
    elem.isActive = false;
  });
};

export default EDC.Games.CountingDots.AnswersBox;
